module.exports = __webpack_public_path__ + "img/06.2140c20a.png";